export default __webpack_public_path__ + "static/media/ethcam.bc299d34.svg";